import Named from "@mapmycustomers/shared/types/base/Named";

const defaultNodeNameGetter = ({ name }: Named): string => name;

export default defaultNodeNameGetter;
